// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"index_breadcrumbs_3MExv","current":"index_current_2bZkp","arrow":"index_arrow_2e1S9"};